<thead>
  <tr>
    <th scope="col">#</th>
    @for (header of headerArray(); track header) {
      <th scope="col">{{ header }}</th>
    }
  </tr>
</thead>
